module.exports = __webpack_public_path__ + "static/media/carrie2.fe8ae594.png";